
import i18n from '@/i18n'
import { sumBy, meanBy } from 'lodash'

export const AggregateType = {
  None: {
    id: 0,
    name: 'none'
  },
  Sum: {
    id: 1,
    name: 'sum'
  },
  Average: {
    id: 2,
    name: 'average'
  },
  WeightedAverage: {
    id: 3,
    name: 'weightedAverage'
  }
}

export function getAggregateTooltip (aggregateType, weightedBy) {
  switch (aggregateType?.id) {
    case AggregateType.WeightedAverage.id: {
      return i18n.t('weightedAverageWeightedBy', { weightedBy: i18n.t(weightedBy) })
    }
    default: return aggregateType ? i18n.t(aggregateType?.name) : undefined
  }
}

export function getAggregatedValueForHeader (dataSet, header, includeZero = false) {
  const dataSetFiltered = includeZero ? dataSet : dataSetNoZeroes(dataSet, header)
  switch (header?.aggregateType?.id) {
    case AggregateType.Sum.id: {
      return sumBy(dataSetFiltered, (d) => d[header.value])
    }
    case AggregateType.Average.id: {
      return meanBy(dataSetFiltered, (d) => d[header.value])
    }
    case AggregateType.WeightedAverage.id: {
      const sum = sumBy(dataSetFiltered, (d) => d[header.value] * d[header.weightedBy])
      const totalTons = sumBy(dataSetFiltered, (d) => d[header.weightedBy])
      return totalTons === 0 ? 0 : sum / totalTons
    }
    default: return 0
  }
}

function dataSetNoZeroes (dataSet, header) {
  return dataSet.filter((d) => d[header.value] !== 0 && d[header.value] != null)
}
